import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config";
import { log } from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getOrderSummaries = async (token, params = {}) => {
    log("welcome in getOrderSummaries from web")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/get_order_summaries_api'
        const result = await axios.get(url, { headers: headers, params })
        log("result.data din axios getOrderSummaries")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getOrderSummaries")
        log(err)
        return { error: true, message: "Error getting order summaries: " + err.message }
    }
}

export const getOrdersList = async (token, params = {}) => {
    log("welcome in getOrdersList from web")
    if (!token || token === "") {
        alert("No token in getOrdersList")
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log("BASE_URL=" + BASE_URL)
        let url = BASE_URL + '/home/get_orders_list_api'
        log("url=" + url)
        log("params:")
        log(params)

        const result = await axios.get(url, { headers: headers, params })
        log("result.data din axios getOrdersList")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getOrdersList")
        log(err)
        return { error: true, message: "Error getting orders list: " + err.message, orders: [] }
    }
}

export const getOrderStatuses = async (token) => {
    log("welcome in getOrderStatuses from web")
    if (!token || token === "") {
        alert("No token in getOrderStatuses")
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/get_order_statuses_api'
        log("url=" + url)

        const result = await axios.get(url, { headers: headers })
        log("result.data din axios getOrderStatuses")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getOrderStatuses")
        log(err)
        return { error: true, message: "Error getting order statuses: " + err.message, statuses: [] }
    }
}

export const payOrderApi = async (token, orderId) => {
    log("welcome in payOrderApi")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/pay_order_api'
        const result = await axios.post(url, { order_id: orderId }, { headers: headers })
        log("result.data din axios payOrderApi")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in payOrderApi")
        log(err)
        return { error: true, message: "Error paying order: " + err.message }
    }
}

export const deleteOrderApi = async (token, orderId) => {
    log("welcome in deleteOrderApi")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/delete_order_api'
        const result = await axios.post(url, { order_id: orderId }, { headers: headers })
        log("result.data din axios deleteOrderApi")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in deleteOrderApi")
        log(err)
        return { error: true, message: "Error deleting order: " + err.message }
    }
}

export const provisionOrderApi = async (token, orderId) => {
    log("welcome in provisionOrderApi")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/provision_order_api'
        const result = await axios.post(url, { order_id: orderId }, { headers: headers })
        log("result.data din axios provisionOrderApi")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in provisionOrderApi")
        log(err)
        return { error: true, message: "Error provisioning order: " + err.message }
    }
}

export const deliverOrderApi = async (token, orderId) => {
    log("welcome in deliverOrderApi")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/deliver_order_api'
        const result = await axios.post(url, { order_id: orderId }, { headers: headers })
        log("result.data din axios deliverOrderApi")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in deliverOrderApi")
        log(err)
        return { error: true, message: "Error delivering order: " + err.message }
    }
}

export const markApiReceivedApi = async (token, orderId) => {
    log("welcome in markApiReceivedApi")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/mark_api_received_order_api'
        const result = await axios.post(url, { order_id: orderId }, { headers: headers })
        log("result.data din axios markApiReceivedApi")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in markApiReceivedApi")
        log(err)
        return { error: true, message: "Error marking API received: " + err.message }
    }
}

export const confirmOrdersPaymentApi = async (token, data) => {
    log("welcome in confirmOrdersPaymentApi")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/confirm_orders_payment_api'
        const result = await axios.post(url, data, { headers: headers })
        log("result.data din axios confirmOrdersPaymentApi")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in confirmOrdersPaymentApi")
        log(err)
        return { error: true, message: "Error confirming payment: " + err.message }
    }
}

export const payOrdersOnlineApi = async (token, data) => {
    log("welcome in payOrdersOnlineApi")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/pay_orders_online_api'
        const result = await axios.post(url, data, { headers: headers })
        log("result.data din axios payOrdersOnlineApi")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in payOrdersOnlineApi")
        log(err)
        return { error: true, message: "Error initiating online payment: " + err.message }
    }
}

export const getPaymentHistoryApi = async (token, params = {}) => {
    log("welcome in getPaymentHistoryApi")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/get_payment_history_api'
        const result = await axios.get(url, { headers: headers, params })
        log("result.data din axios getPaymentHistoryApi")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in getPaymentHistoryApi")
        log(err)
        return { error: true, message: "Error getting payment history: " + err.message, batches: [] }
    }
}

export const exportOrdersList = async (token, params = {}) => {
    log("welcome in exportOrdersList")
    if (!token || token === "") {
        return { error: true, message: "No token provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
        let url = BASE_URL + '/home/export_orders_list_api'
        const result = await axios.get(url, { headers: headers, params, responseType: 'blob' })
        return result.data
    } catch (err) {
        log("Error in exportOrdersList")
        log(err)
        return { error: true, message: "Error exporting orders: " + err.message }
    }
}

const useGetOrdersAPI = () => {
    return { error, getOrderSummaries, getOrdersList, getOrderStatuses, payOrderApi, deleteOrderApi, provisionOrderApi, deliverOrderApi, markApiReceivedApi, confirmOrdersPaymentApi, payOrdersOnlineApi, getPaymentHistoryApi, exportOrdersList };
}

export default useGetOrdersAPI
